module.exports = __webpack_public_path__ + "img/top.f403c28e.jpg";